import * as React from 'react';
import './ReturnsRmaTableMobile.scss';
import ReturnsRmaRowMobile from '../ReturnsRmaRowMobile';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IReturnDetail } from 'src/services/returns/typings';

interface IReturnsRmaTableMobileProps {
  rmaData: IReturnDetail[];
  rmaDataFixed: IReturnDetail[];
  poNumber: string;
  handleChangePoNumber: (e: any) => void;
  rmaAction: string;
  handleChangeRmaData: (id: number) => void;
  handleChangeRmaDataInput: (value: IReturnDetail[]) => void;
  totalShippingCharge:number;
  t?: any;
}

const ReturnsRmaTableMobile: React.FC<IReturnsRmaTableMobileProps> = props => {
  const {
    rmaData,
    poNumber,
    handleChangePoNumber,
    rmaAction,
    handleChangeRmaData,
    rmaDataFixed,
    handleChangeRmaDataInput,
    totalShippingCharge,
    t
  } = props;

  const calculateEstimated = (): number => {
    let result = 0;

    rmaData.forEach(rma => {
      result += rma.returnAmount;
    });

    if(totalShippingCharge>0){
      return result-totalShippingCharge;
    }else{
      return result;
    }

  };

  return (
    <div className="rp-returns-rma-table-mobile">
      {rmaData.map((rma, index) => (
        <ReturnsRmaRowMobile
          key={rma.id}
          rmaData={rmaData}
          rmaItemFixed={rmaDataFixed[index]}
          handleChangeRmaData={handleChangeRmaData}
          action={rmaAction}
          rmaItem={rma}
          handleChangeRmaDataInput={handleChangeRmaDataInput}
        />
      ))}
      <div className="container-fluid">
        <div className="row rp-returns-rma-table-mobile-po-container">
          <div className="col-12">
            <label
              htmlFor="poNumberMobile"
              className="rp-returns-rma-table-mobile-po-label"
            >
              {t('myReturns.pONumber')} {t('common.optional')}
            </label>
            <input
              id="poNumberMobile"
              type="text"
              value={poNumber}
              onChange={handleChangePoNumber}
              className="rp-returns-rma-table-mobile-po-input"
              maxLength={15}
            />
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row rp-returns-rma-table-mobile-estimated-container">
          <div className="col-12 d-flex justify-content-center">
            <p className="rp-returns-rma-table-mobile-estimated">
              {`${t(
                'myReturns.totalEstimatedCredit'
              )} ${localeFormatingInstance.formatCurrency(
                calculateEstimated()
              )}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnsRmaTableMobile;
